var React = require('react');
var CustomStylesMixin = require('./templates/custom_styles_mixin');

var createReactClass = require('create-react-class');
module.exports = createReactClass({

  displayName: 'PageToggler',

  mixins: [CustomStylesMixin],

  setPageType : function (event) {
    event.preventDefault();
    this.props.onChange(event.target.dataset.type);
  },

  activeTab : function (name) {
    return (this.props.page_type === name) ? 'active' : null;
  },

  togglerColor : function(name) {
    return (this.props.page_type === name) ? this.mergeStyles(this.primary_text_color(), this.primaryBorderColor()) : this.secondary_text_color()
  },

  render : function () {
    var type = this.props.page_type || '503';
    return (
      <div className="page-toggler">
        <a href="#" className={this.activeTab('503')} style={this.togglerColor('503')} onClick={this.setPageType} data-type="503">503</a>
        <a href="#" className={this.activeTab('404')} style={this.togglerColor('404')} onClick={this.setPageType} data-type="404">404</a>
        <a href="#" className={this.activeTab('maintenance')} style={this.togglerColor('maintenance')} onClick={this.setPageType} data-type="maintenance">Maintenance</a>
      </div>
    )
  }

});



// WEBPACK FOOTER //
// ./app/assets/javascripts/components/better_error_pages/page_toggler_component.jsx